import React, { useState } from 'react'
import { MySwal } from '../../../lib/swal'
import axios from '../../../lib/axios'
import errorHandler from '../../../helpers/errorHandler';
import { isStrongPassword, PASSWORD_RULE_TEXT } from '../../../helpers/passwordPolicy';

const FormChangePassword = (props) => {
    // console.log(props.user)
    const [disabled, setDisabled] = useState(false);
    const [newPassword, setnewPassword] = useState('')

    const handleChangePassword = () => {
        if (!isStrongPassword(newPassword)) {
            MySwal.fire({
                icon: 'warning',
                title: 'Oops, Password terlalu lemah!',
                text: `Password harus ${PASSWORD_RULE_TEXT}`,
            })
            return
        }
        setDisabled(true)
        const requestBody = {
            newPassword: newPassword,
            id: props?.userId
        }
        // console.log(requestBody)
        // return false

        axios.post(`users/users/reset-password`, requestBody, {
            headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Password has been successfully changed, Please login again!',
                    })
                    setDisabled(false)

                    props.close()
                }
            })
            .catch(err => {
                if (err !== "") {
                    setDisabled(false)
                    console.log(err?.response?.data)
                    errorHandler({ err: err?.response?.data || err })
                }
            });
    }

    return (
        <>
            <div className="mb-3 row">
                <div className='col-lg-12'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="newPassword" className="col-form-label">Password Baru</label>
                </div>
                <div className='col-lg-12'>
                    <input onChange={(e) => setnewPassword(e.target.value)} style={{ fontSize: '14px', color: '#191919', fontWeight: '500', borderColor: (newPassword.length > 0 && !isStrongPassword(newPassword)) ? '#F1416C' : '' }} type="password" className="form-control" id="newPassword" value={newPassword} placeholder='******' />
                    <p className='mt-2 mb-0' style={{ fontSize: '12px', color: (newPassword.length > 0 && !isStrongPassword(newPassword)) ? '#F1416C' : '' }}>{PASSWORD_RULE_TEXT}</p>
                </div>
            </div>
            <hr></hr>
            <div className="mb-3 row d-flex" style={{ textAlign: 'right' }}>
                <div>
                    <button onClick={() => props.close()} className="btn btn-bg-white" style={{ marginRight: '10px' }}>Batal</button>
                    <button onClick={handleChangePassword} className="btn btn-success" disabled={disabled}>
                        {
                            disabled === true ?
                                'Mohon tunggu...'
                                :
                                'Simpan Perubahan'
                        }
                    </button>
                </div>

            </div>
        </>
    )
}

export default FormChangePassword
